import { useContext } from "react";
import { ErrorContext } from "context/ErrorContext";

export const useErrorContext = () => {
  const context = useContext(ErrorContext);

  return context;
};